import React from 'react'
import Svg from 'assets/telegram.svg'
import ContactButton from './ContactButton'

export default () => (
  <ContactButton href="https://t.me/yana_tsaryk" svgId={Svg.id!} tooltip="Telegram" />
)
